export const systemProperties = [
  'productId',
  'variantId',
  'modifiersId',
  'styleCode',
  'price',
  'salePrice',
  'calculatedPrice',
  'retailPrice',
  'currencyCode',
  'productHeightInMm',
  'productWidthInMm',
  'productLengthInMm',
  'productBleedHeightInMm',
  'productBleedWidthInMm',
  'productBleedLengthInMm',
  'variantSku',
]
